export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
export const AUTH_REGISTER = "AUTH_REGISTER";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_AUTH_ERROR = "SET_AUTH_ERROR";
export const REQ_AUTH = "REQ_AUTH";
